import VueCompat, { createApp } from 'vue';
import VueMeta from 'vue-meta';
import Vuelidate from 'vuelidate';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueSweetalert2 from 'vue-sweetalert2';
import VueScrollactive from 'vue-scrollactive';
import '@sweetalert2/theme-bootstrap-4/bootstrap-4.scss';
import axios from 'axios';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowAltCircleRight,
  faPaperclip,
  faPortrait,
  faTrash,
  faPlus,
  faCheckSquare,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faExchangeAlt,
  faUndo,
  faSquare,
  faUser,
  faUsers,
  faTachometerAlt,
  faCog,
  faUserCircle,
  faSignOutAlt,
  faEdit,
  faTrashAlt,
  faLongArrowAltLeft,
  faSave,
  faListAlt,
  faChartPie,
  faDownload,
  faUpload,
  faFilter,
  faSearch,
  faBell,
  faClipboardList,
  faSms,
  faQuestionCircle,
  faRecordVinyl,
  faPhone,
  faList,
  faChartLine,
  faComments,
  faDatabase,
  faStore,
  faStickyNote,
  faMailBulk,
  faCalendarCheck,
  faCopyright,
  faTags,
  faGifts,
  faEye,
  faEyeSlash,
  faSyncAlt,
  faMobile,
  faPlay,
  faEnvelope,
  faIdBadge,
  faCoins,
  faTicketAlt,
  faBarcode,
  faPrint,
  faCopy,
  faRupeeSign,
  faFile,
  faFileAlt,
  faFileExcel,
  faFilePdf,
  faFilePowerpoint,
  faImage,
  faHeadphones,
  faInfoCircle,
  faCheck,
  faRetweet,
  faSort,
  faMoon,
  faSun,
  faLeaf,
  faBoxes,
  faUserTie,
  faUserTag,
  faHandshake,
  faIdCard,
  faAd,
  faHandHoldingUsd,
  faAt,
  faPalette,
  faClone,
  faShoppingBag,
  faBorderAll,
  faChartBar,
  faReceipt,
  faSitemap,
  faPen,
  faFingerprint,
  faCloudUploadAlt,
  faBars,
  faClock,
  faArrowUp,
  faEllipsisV,
  faSlidersH,
  faBook,
  faCalendar,
  faHome,
  faArrowLeft,
  faScroll
} from '@fortawesome/free-solid-svg-icons';
import {
  faCalendar as faCalendarRegular,
  faEnvelope as faEnvelopeRegular,
  faBell as faBellRegular,
  faTrashAlt as faTrashAltRegular
} from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import ConfigService from '@/services/configService';

import VueTour from 'vue-tour';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

import SimpleLayout from './views/Layout/SimpleLayout.vue';
import BackendLayout from './views/Layout/BackendLayout.vue';
import AdminFormSelect from './components/AdminFormSelect.vue';
import legacyModelDirective from './helper/legacyModelDirective';

require('vue-tour/dist/vue-tour.css');

library.add(
  faArrowAltCircleRight,
  faPaperclip,
  faPortrait,
  faTrash,
  faTrashAlt,
  faPlus,
  faCheckSquare,
  faSquare,
  faUser,
  faUsers,
  faTachometerAlt,
  faCog,
  faUserCircle,
  faSignOutAlt,
  faEdit,
  faLongArrowAltLeft,
  faSave,
  faListAlt,
  faChartPie,
  faDownload,
  faUpload,
  faFilter,
  faSearch,
  faBell,
  faClipboardList,
  faSms,
  faQuestionCircle,
  faRecordVinyl,
  faPhone,
  faList,
  faChartLine,
  faComments,
  faDatabase,
  faStore,
  faStickyNote,
  faMailBulk,
  faCalendarCheck,
  faCopyright,
  faTags,
  faGifts,
  faEye,
  faEyeSlash,
  faSyncAlt,
  faMobile,
  faPlay,
  faEnvelope,
  faIdBadge,
  faCoins,
  faTicketAlt,
  faBarcode,
  faPrint,
  faCopy,
  faRupeeSign,
  faFile,
  faFileAlt,
  faFileExcel,
  faFilePdf,
  faFilePowerpoint,
  faImage,
  faHeadphones,
  faInfoCircle,
  faCheck,
  faRetweet,
  faSort,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faExchangeAlt,
  faUndo,
  faSun,
  faMoon,
  faLeaf,
  faBoxes,
  faUserTie,
  faUserTag,
  faHandshake,
  faIdCard,
  faAd,
  faHandHoldingUsd,
  faAt,
  faPalette,
  faClone,
  faShoppingBag,
  faBorderAll,
  faChartBar,
  faReceipt,
  faSitemap,
  faPen,
  faFingerprint,
  faCloudUploadAlt,
  faBars,
  faClock,
  faArrowUp,
  faEllipsisV,
  faSlidersH,
  faBook,
  faCalendar,
  faHome,
  faArrowLeft,
  faScroll,
  faCalendarRegular,
  faEnvelopeRegular,
  faBellRegular,
  faTrashAltRegular,
  {
    prefix: 'fas',
    iconName: 'indian-rupee-sign',
    icon: faRupeeSign.icon
  },
  {
    ...faTrashAltRegular,
    iconName: 'trash'
  }
);

ConfigService.loadConfig().then(() => {
  axios.defaults.baseURL = ConfigService.get('apiUrl');
  const authKey = localStorage.getItem('auth-key');
  if (authKey) {
    axios.defaults.headers.common.Authorization = authKey;
  }

  const app = createApp(App);
  const normalizeSwalOptions = options => {
    if (options && typeof options === 'object' && options.type && !options.icon) {
      return {
        ...options,
        icon: options.type,
        type: undefined
      };
    }
    return options;
  };

  app.config.globalProperties.$set = (target, key, value) => {
    Reflect.set(target, key, value);
    return value;
  };
  app.config.globalProperties.$delete = (target, key) => {
    Reflect.deleteProperty(target, key);
  };

  app.mixin({
    beforeCreate() {
      if (!this.constructor || !this.constructor.extend) {
        Object.defineProperty(this, 'constructor', {
          configurable: true,
          value: VueCompat
        });
      }
    }
  });
  app.use(VueMeta, { refreshOnceOnNavigation: true });
  app.use(Vuelidate);
  app.use(BootstrapVue);
  app.directive('model', legacyModelDirective);
  app.use(VueScrollactive);
  app.use(VueSweetalert2, {});
  const rawSwal = app.config.globalProperties.$swal;
  if (rawSwal) {
    const swal = (options, ...args) => rawSwal(normalizeSwalOptions(options), ...args);
    Object.assign(swal, rawSwal);
    swal.fire = (options, ...args) => rawSwal.fire(normalizeSwalOptions(options), ...args);
    app.config.globalProperties.$swal = swal;
    VueCompat.swal = swal;
  }
  app.use(VueTour);
  app.use(router);
  app.use(store);
  app.component('datetime', Datetime);
  app.component('font-awesome-icon', FontAwesomeIcon);
  app.component('simple-layout', SimpleLayout);
  app.component('backend-layout', BackendLayout);
  app.component('admin-form-select', AdminFormSelect);
  app.mount('#app');
});
